"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMenuItemRadio = void 0;
const useMenuItemRadio = _ref => {
  let {
    selectedValue,
    setSelectedValue
  } = _ref;
  return {
    getMenuItemRadioProps: radioProps => {
      return {
        ...radioProps,
        selectedValue,
        onClick: (selectedOption, e, log) => {
          radioProps.onClick?.(selectedOption, e, log);
          setSelectedValue(selectedOption);
        }
      };
    }
  };
};
exports.useMenuItemRadio = useMenuItemRadio;
//# sourceMappingURL=useMenuItemRadio.js.map